<template lang="html">
  <div class="monitor">
    <v-header :name="name"></v-header>
    <div class="container">
      <p class="title">百色市田阳县</p>
      <div class="select">
        <div class="item" @click="up">
          <span style="margin-right:30px" class="monitor-name">百色市田阳县气象监控站</span>
          <span>
            <span class="time">16：00 更新</span>
            <img class="down-arrow" src="../../../static/img/monitor/5.png" alt="">
          </span>
          <div class="options"  v-show="show">
            <div v-for="(item,index) in options" :key="item.id">
              {{item.text}}
            </div>
          </div>
        </div>
        <div class="item item1">
          <span>{{listData[num].temperature}}°C</span>
          <span>
            <span>晴</span>
            <img src="../../../static/img/monitor/8.png" alt="">
          </span>
        </div>
        <div class="item item1">
          <span>
            <img src="../../../static/img/monitor/1.png" alt="">
            <span>湿度{{listData[num].humidity}}%</span>
          </span>
          <span>
            <img src="../../../static/img/monitor/2.png" alt="">
            <span>西南风 {{listData[num].winds}} 级</span>
          </span>
        </div>
        <div class="item item1">
          <span><span class="index-mark">优</span></span>
          <span>
            <img src="../../../static/img/monitor/3.png" alt="">
            <span>空气指数: {{listData[num].air}}</span>
          </span>
        </div>
      </div>

      <div class="detail">
        <div class="detail-item">
          <p class="name">土壤温度</p>
          <p class="data"><span class="num">24</span><span class="unit">℃</span></p>
        </div>
        <div class="detail-item">
          <p class="name">土壤湿度</p>
          <p class="data"><span class="num">43</span><span class="unit">%</span></p>
        </div>
        <div class="detail-item">
          <p class="name">水质PH</p>
          <p class="data"><span class="num">6.9</span><span class="unit"></span></p>
        </div>
        <div class="detail-item">
          <p class="name">水质温度</p>
          <p class="data"><span class="num">23</span><span class="unit">℃</span></p>
        </div>
        <div class="detail-item">
          <p class="name">CO2浓度</p>
          <p class="data"><span class="num">453</span><span class="unit">ppm</span></p>
        </div>
        <div class="detail-item">
          <p class="name">PM2.5</p>
          <p class="data"><span class="num">13</span><span class="unit">ug/m²</span></p>
        </div>
        <div class="detail-item">
          <p class="name">土壤铵根离子</p>
          <p class="data"><span class="num">1.0</span><span class="unit">ppm</span></p>
        </div>
        <div class="detail-item">
          <p class="name">土壤硝酸离子</p>
          <p class="data"><span class="num">0</span><span class="unit">ppm</span></p>
        </div>
        <div class="detail-item">
          <p class="name">土壤钾离子</p>
          <p class="data"><span class="num">41.93</span><span class="unit">ppm</span></p>
        </div>
        <div class="detail-item">
          <p class="name">铜离子</p>
          <p class="data"><span class="num">0.01</span><span class="unit">ppm</span></p>
        </div>
        <div class="detail-item">
          <p class="name">铅离子</p>
          <p class="data"><span class="num">0.3</span><span class="unit">ppm</span></p>
        </div>
        <div class="detail-item">
          <p class="name">镉离子</p>
          <p class="data"><span class="num">0.01</span><span class="unit">ppm</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import header from 'components/common/header'
export default {
  data() {
    return {
      name: '田阳县农业大脑——环境监测中心',
      show: false,
      options: [
        { text: '百色市田阳县气象监控站', value: false }
      ],
      listData: [
        { temperature: 26, humidity: 94, winds: 1, air: 40 },
        { temperature: 27, humidity: 93, winds: 2, air: 43 },
        { temperature: 32, humidity: 91, winds: 2, air: 46 },
        { temperature: 30, humidity: 95, winds: 2, air: 55 },
        { temperature: 25, humidity: 89, winds: 3, air: 70 }
      ],
      num: 0
    }
  },
  mounted() {
    const currentHour = new Date().getHours()
    if (currentHour <= 8) {
      this.num = 0
    } else if (currentHour <= 11 && currentHour > 8) {
      this.num = 1
    } else if (currentHour <= 14 && currentHour > 11) {
      this.num = 2
    } else if (currentHour <= 16 && currentHour > 14) {
      this.num = 3
    } else {
      this.num = 4
    }
  },
  methods: {
    up() {
      this.show = !this.show
    }
  },
  components: {
    'v-header': header
  }
}

</script>

<style lang="stylus" scoped>
.monitor {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: url('../../../static/img/common/bg.png');
  background-size: 100% 100%;
}

.container {
  height: 100%;
  padding: 0 15px;

  .title {
    font-size: 30px;
    color: #fff;
  }

  .select {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
    color: #fff;
    font-size: 22px;
    position: relative;

    .item {
      width: 435px;
      height: 60px;
      line-height: 60px;
      position: relative;
      background: url('../../../static/img/monitor/4.png');
      padding: 0 18px;
      box-sizing: border-box;
      justify-content: space-between;

      .options {
        width: 350px;
        padding-left: 20px;
        background: rgba(0, 36, 90, 0.7);
        border: 1px solid rgba(73, 117, 233, 1);
        positon: absolute;
        left: 100px;
        bottom: 0;
      }

      .monitor-name {
        font-size: 20px;
      }

      .time {
        font-size: 14px;
        margin-right: 10px;
      }

      img {
        vertical-align: middle;
      }
    }

    .item1 > span {
      width: 50%;
      text-align: center;

      img {
        margin: 0 10px;
      }
    }

    .item1>span:nth-child(1) {
    }

    .index-mark {
      padding: 4px 20px;
      background: rgba(130, 207, 79, 1);
      border-radius: 8px;
    }
  }

  .detail {
    padding-left: 12px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;

    .detail-item {
      width: 446px;
      height: 264px;
      padding: 15px 20px;
      margin-top: 20px;
      margin-right: 20px;
      background: url('../../../static/img/monitor/6.png');
      display: flex;

      .name {
        font-size: 20px;
        color: #fff;
      }

      .data {
        width: 234px;
        height: 234px;
        line-height: 234px;
        text-align: center;
        background: url('../../../static/img/monitor/7.png');
        background-position: 40% 66%;

        .num {
          font-size: 50px;
          color: #9EEEF5;
        }

        .unit {
          font-size: 24px;
          color: #BDE3EE;
        }
      }

      .oprate {
        display: flex;
        flex-direction: column-reverse;
        margin-left: 16px;

        span {
          font-size: 16px;
          color: #77CAD8;
          padding: 3px 4px;
          border: 1px solid rgba(119, 202, 216, 1);
          border-radius: 2px;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?53d5419e